<style type="text/css" media="screen">

.filter-btn{
	display: inline-block;
	background-color: #ffff;

}
.description{
	white-space: nowrap; 
	width: 450px; 
	overflow: hidden;
	text-overflow: ellipsis; 
}


</style>

<template>
	<div>

		<!-- filter and add new btn  -->
		<v-row class="mb-8">
			<v-col cols="12" md="6" class="mt-2">
				<div class="filter-btn status-text-filter px-4 py-1 mx-2 cursor-pointer"  v-for="(item,i) in filter_ticket_status_options" :key="i"  @click="applyFilter(item.value)" :class="filter_ticket_status==item.value?'elevation-1 border-rounded':'elevation-0'" >
					{{item.text}}
					<v-icon v-if="i>0" size="10" style="margin-top:-3px;" class="pl-2" :color="i==1?'#EB5757':'#27AE60'">
						mdi-checkbox-blank-circle
					</v-icon>
				</div>
			</v-col>
			<v-col cols="12" md="6">
				<v-text-field
				v-model="support_ticket_serch_query"
				:placeholder="$lang.TICKET_SEARCH"
				outlined
				rounded
				dense
				append-icon="mdi-magnify"
				@keyup="getTicketList"
				single-line
				hide-details
				></v-text-field>
			</v-col>
		</v-row>

		<v-data-table
		:headers="headers"
		:items="ticket_list"
		item-key="name"
		:hide-default-footer="true"
		:disable-sort="true"
		:items-per-page="$keys.PAGE_LENGTH"
		class="elevation-1 custome-header-bg custome-table-body"
		:loading="table_loading"
		>
		<!-- retailer info -->
		<template v-slot:item.retailer_firm_name="{ item }">
			<p>{{item.retailer_firm_name}}</p>
			<p>{{$lang.MOBILE_PREFIX}}{{item.retailer_mobile_number}}</p>
		</template>	
		<!-- status -->
		<template v-slot:item.status="{ item }">
			<span :class="'issue-'+item.status.toLowerCase()">{{item.status}}</span>
		</template>	
		<!-- action -->
		<template v-slot:item.action="{ item }">
			<v-btn small fab text @click="$router.push({name:'support-ticket-details',params:{ticket_id:encript(item.ticket_id)}})">	
				<img src="../../assets/arrow-right.svg" alt="">	
			</v-btn>	
		</template>	
		<!--  empty state  -->
		<template v-slot:no-data>
			<empty-list :message="$lang.EMPTY_TICKET"/>
		</template>	


	</v-data-table>

	<v-pagination class="custome-pagination"  v-model="page_number" :total-visible="7" :length="total_page_count"
	@input="getTicketList	"></v-pagination>

</div>
</template>

<script type="text/javascript">

export default{
	data(){
		return{
			ticket_list:[],
			table_loading:false,
			page_number:1,
			total_page_count:1,
			support_ticket_serch_query:"",
			filter_ticket_status_options:[
			{text:'All',is_active:true,value:null},
			{text:'Open Ticket',is_active:false,value:"Open"},
			{text:'Closed Ticket',is_active:false,value:"Close"}
			],
			filter_ticket_status:null,
			headers: [
			{
				text: 'Issue #',
				align: 'start',
				sortable: false,
				value: 'ticket_id',
			},
			{ text: 'Shipment ID ', value: 'shipment_id' },
			{ text: 'Retailer Info', value: 'retailer_firm_name' },
			{ text: 'Challan', value: 'challan_number' },
			{ text: 'Category', value: 'category' },
			{ text: 'Status', value: 'status' },
			// { text: 'Description', value: 'description' },
			{ text: '', value: 'action' , width:"30"},
			],
		}
	},
	created(){
		this.getTicketList(false)
	},
	methods:{
		getTicketList(is_cancel=true){
			const self=this
			this.$store.dispatch('setPageLoader', true)	
			self.table_loading=true

			let params={
				page_number:this.page_number,
				page_length:this.$keys.PAGE_LENGTH,
				search_query:this.support_ticket_serch_query,
			};

			if (self.filter_ticket_status){
				// let st_fi_li=[self.filter_ticket_status]

				params.filter_ticket_status=self.filter_ticket_status;
			}	

			const successHandler = (response) => {
				console.log(response)
				if (response.data.success){
					self.ticket_list=response.data.ticket_list
					self.total_page_count=response.data.total_page_count
				}
			};
			const finallyHandler = () => {
				self.table_loading=false
				this.$store.dispatch('setPageLoader', false)
			};

			self.request_GET( self,self.$urls.TICKET_LIST,params,successHandler,null,null,finallyHandler,is_cancel)


		},
		applyFilter(status){
			this.filter_ticket_status=status;
			this.getTicketList()
		},
		gotoRaiseIssue(){
			this.$store.dispatch('backbtn/setBackBtn', {flag:true, pre_route_name:'support-tickets'})
			this.$router.push({name:"raise-an-issue"})
		}
	}

}

</script>